import { render, staticRenderFns } from "./enter-invite-code.vue?vue&type=template&id=518b9b22&scoped=true"
import script from "./enter-invite-code.vue?vue&type=script&lang=js"
export * from "./enter-invite-code.vue?vue&type=script&lang=js"
import style0 from "./enter-invite-code.vue?vue&type=style&index=0&id=518b9b22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b9b22",
  null
  
)

export default component.exports